var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0736 5.66667H11.2611V4.04762C11.2611 1.81333 9.44111 0 7.19861 0C4.95611 0 3.13611 1.81333 3.13611 4.04762V5.66667H2.32361C1.42986 5.66667 0.698608 6.39524 0.698608 7.28571V15.381C0.698608 16.2714 1.42986 17 2.32361 17H12.0736C12.9674 17 13.6986 16.2714 13.6986 15.381V7.28571C13.6986 6.39524 12.9674 5.66667 12.0736 5.66667ZM7.19861 12.9524C6.30486 12.9524 5.57361 12.2238 5.57361 11.3333C5.57361 10.4429 6.30486 9.71429 7.19861 9.71429C8.09236 9.71429 8.82361 10.4429 8.82361 11.3333C8.82361 12.2238 8.09236 12.9524 7.19861 12.9524ZM9.71736 5.66667H4.67986V4.04762C4.67986 2.66333 5.80923 1.5381 7.19861 1.5381C8.58798 1.5381 9.71736 2.66333 9.71736 4.04762V5.66667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockedIcon);
export default __webpack_public_path__ + "static/media/lockedIcon.884a0b280b3747c438d04a9bd87ad2c2.svg";
export { ForwardRef as ReactComponent };